<template>
  <v-container fluid class="pa-4">
    <!-- بنر -->
    <v-banner
      v-if="showbanner"
      single-line
      color="amber lighten-5"
      class="mb-4 rounded-lg"
      elevation="2"
    >
      <v-icon slot="icon" color="amber darken-2"
        >mdi-information-outline</v-icon
      >
      <span class="font-weight-medium">{{
        $t("language.only_manual_now")
      }}</span>
      <br />
      <span class="text-caption grey--text text--darken-1">{{
        $t("language.ai_coming_soon")
      }}</span>
      <template v-slot:actions>
        <v-btn text small color="primary" @click="showbanner = false">
          {{ $t("language.got_it") }}
        </v-btn>
      </template>
    </v-banner>

    <!-- انتخاب زبان اصلی -->
    <v-select
      v-model="selectedSourceLang"
      :items="allLanguages"
      :label="$t('language.origin_language')"
      outlined
      class="mt-3"
      item-text="name"
      return-object
      @change="onSourceLangChange"
    >
      <template v-slot:item="{ item }">
        <img :src="item.flag" width="20" class="mr-2 rounded" />
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
          <v-list-item-subtitle class="text--secondary">
            {{ $t(`language.lang.${item.lang}`) }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
      <template v-slot:selection="{ item }">
        <img :src="item.flag" width="20" class="mr-2 rounded" />
        {{ item.name }} ({{ $t(`language.lang.${item.lang}`) }})
      </template>
    </v-select>

    <!-- نمایش زبان اصلی فعلی -->
    <v-col cols="12" class="text-center mb-4">
      <v-chip
        :color="activeLang === currentSourceLang ? 'white' : 'green'"
        :text-color="activeLang === currentSourceLang ? 'green' : 'white'"
        class="font-weight-bold pl-2"
        :outlined="currentSourceLang === activeLang"
        :style="{
          border:
            currentSourceLang === activeLang
              ? '2px solid green !important'
              : 'none',
        }"
        @click="selectLanguagedefault(currentSourceLang)"
      >
        <v-icon
          v-if="currentSourceLang === activeLang"
          left
          small
          color="green"
          class="mr-1"
        >
          mdi-check
        </v-icon>
        <img :src="sourceLangObj.flag" width="20" class="mr-2 rounded" />
        {{ $t("language.origin_language") }}:
        {{ $t(`language.lang.${currentSourceLang}`) }}
      </v-chip>
    </v-col>

    <!-- دکمه حذف همه -->
    <v-btn
      v-if="pendingTargetLanguages.length > 0"
      icon
      color="error"
      @click="pendingTargetLanguages = []"
      class="mb-3"
      :title="$t('language.remove_all')"
    >
      <v-icon>mdi-delete-sweep</v-icon>
    </v-btn>

    <!-- انتخاب زبان‌های هدف -->
    <v-select
      v-model="pendingTargetLanguages"
      :items="availableTargetLanguages"
      :label="$t('language.target_languages')"
      multiple
      chips
      deletable-chips
      return-object
      outlined
      class="mt-3"
    >
      <template v-slot:selection="{ item }">
        <v-chip
          close
          small
          class="ma-1 elevation-2"
          :outlined="item.lang === activeLang"
          :style="{
            border: item.lang === activeLang ? '2px solid #4CAF50' : 'none',
          }"
          :color="getChipColor(item)"
          :text-color="getTextColor(item)"
          @click:close="removeTargetLang(item)"
          @click.stop="openAndSelect(item)"
        >
          <v-icon v-if="item.lang === activeLang" left x-small color="green"
            >mdi-check</v-icon
          >
          <v-icon left small>{{ getIcon(item) }}</v-icon>
          <img :src="item.flag" width="20" class="mr-2 rounded" />
          {{ $t(`language.lang.${item.lang}`) }}
        </v-chip>
      </template>
      <template v-slot:item="{ item, attrs, on }">
        <v-list-item v-bind="attrs" v-on="on">
          <v-list-item-action>
            <v-checkbox :input-value="isTargetLangSelected(item)"></v-checkbox>
          </v-list-item-action>
          <img :src="item.flag" width="20" class="mr-2 rounded" />
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle class="text--secondary">
              {{ $t(`language.lang.${item.lang}`) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:prepend-item>
        <v-list-item @click="toggleSelectAll">
          <v-list-item-action>
            <v-checkbox :input-value="allTargetSelected"></v-checkbox>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{
              $t("language.selectAll")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </template>
    </v-select>
    <v-divider class="my-6"></v-divider>

    <!-- دکمه اعمال تغییرات با بج و کلاس btn-download -->
    <v-slide-y-transition>
      <div v-if="hasPendingChanges" class="mt-4 text-center">
        <v-alert
          v-if="!$vuetify.breakpoint.xs"
          dense
          outlined
          type="info"
          prominent
          text
          :class="{
            'mb-3': !$vuetify.breakpoint.xs,
            'ma-0': $vuetify.breakpoint.xs,
          }"
          class="mb-3"
        >
          <div
            :class="{
              'd-flex align-center justify-space-between':
                !$vuetify.breakpoint.xs,
              'd-flex align-center flex-column flex-wrap':
                $vuetify.breakpoint.xs,
            }"
          >
            <span
              class="font-weight-medium"
              :class="{
                'd-flex align-center justify-space-between':
                  !$vuetify.breakpoint.xs,
                'd-flex align-center flex-column flex-wrap':
                  $vuetify.breakpoint.xs,
              }"
            >
              {{ use_lang(pendingCount) }} {{ $t("language.changes_pending") }}
            </span>
            <div class="d-flex flex-row flex-wrap mx-2">
              <v-badge
                :content="pendingCount"
                color="error"
                overlap
                offset-x="20"
                offset-y="20"
                class="btn-download-badge"
              >
                <template v-slot:badge>
                  <span class="white--text font-weight-bold">{{
                    use_lang(pendingCount)
                  }}</span>
                </template>
                <v-btn
                  :loading="applying"
                  :disabled="applying"
                  @click="applyPendingChanges"
                  class="btn-download"
                  depressed
                  large
                >
                  {{ $t("language.apply_changes") }}
                  <v-icon right>mdi-check-circle</v-icon>
                </v-btn>
              </v-badge>
              <v-btn
                @click="cancelChanges"
                depressed
                large
                class="btn-cancel"
                :disabled="applying || !hasPendingChanges"
              >
                <v-icon left>mdi-undo-variant</v-icon>
                {{ $t("language.cancel_changes") }}
              </v-btn>
            </div>
          </div>
        </v-alert>
        <!--else-->
        <div
          v-else
          dense
          outlined
          type="info"
          :class="{
            'mb-3': $vuetify.breakpoint.xs,
            'ma-0': !$vuetify.breakpoint.xs,
          }"
          prominent
          text
        >
          <div
            :class="{
              'd-flex align-center justify-space-between':
                $vuetify.breakpoint.xs,
              'd-flex align-center flex-column flex-wrap':
                !$vuetify.breakpoint.xs,
            }"
          >
            <span>
              {{ use_lang(pendingCount) }} {{ $t("language.changes_pending") }}
            </span>
            <v-badge
              :content="pendingCount"
              color="error"
              offset-x="15%"
              offset-y="35%"
              left
              overlap
              class="ml-2"
            >
              <template v-slot:badge>
                <span class="text-caption font-weight-bold white--text">{{
                  use_lang(pendingCount)
                }}</span>
              </template>

              <v-btn
                :loading="applying"
                :disabled="applying"
                @click="applyPendingChanges"
                class="btn-download"
                depressed
                large
              >
                {{ $t("language.apply_changes") }}
                <v-icon right>mdi-check-circle</v-icon>
              </v-btn>
            </v-badge>
            <v-btn
              @click="cancelChanges"
              depressed
              large
              class="btn-cancel"
              :disabled="applying || !hasPendingChanges"
            >
              <v-icon left>mdi-undo-variant</v-icon>
              {{ $t("language.cancel_changes") }}
            </v-btn>
          </div>
        </div>
      </div>
    </v-slide-y-transition>

    <!-- دیالوگ انتخاب روش ترجمه -->
    <custom-popup
      v-if="dialog && !$root.isTranslating"
      v-model="dialog"
      :cons="{ title: $t('language.translation_method') }"
      hide-confirm
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">{{ current?.name }}</v-card-title>
        <v-card-text class="body-1">{{
          $t("language.translation_method")
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="blue" @click="setStatus('edited')">
            <v-icon left>mdi-account-edit</v-icon>
            {{ $t("language.manual_translation") }}
          </v-btn>
          <v-badge
            :content="$t('coming_soon')"
            color="warning"
            offset-x="20"
            offset-y="10"
            left
            overlap
            class="ml-2"
          >
            <template v-slot:badge>
              <span class="text-caption font-weight-bold white--text">{{
                $t("coming_soon")
              }}</span>
            </template>
            <v-btn
              text
              color="purple"
              @click="setStatus('ai_translated')"
              :disabled="true"
            >
              <v-icon left>mdi-robot</v-icon>
              {{ $t("language.ai_translation") }}
            </v-btn>
          </v-badge>
        </v-card-actions>
      </v-card>
    </custom-popup>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "managmentLanguage",
  props: {
    value: { type: Object, required: true },
    mainData: { type: Object, required: true },
  },
  data() {
    return {
      initialSourceLang: null,
      initialTargetLanguages: [],
      current: null,
      dialog: false,
      showbanner: true,
      applying: false,
      theme: "MobileViwer",
      orders: [
        { name: "userName" },
        { name: "workField" },
        { name: "aboutUs" },
        { name: "video_gallery" },
        { name: "photo" },
        { name: "extraFields" },
        { name: "phoneNumber" },
        { name: "fax" },
        { name: "location" },
        { name: "codePostal" },
        { name: "email" },
        { name: "website" },
      ],
      pendingSourceLang: null,
      pendingTargetLanguages: [],
      selectedSourceLang: null,
      activeLang: null,
      data: {},
    };
  },
  computed: {
    ...mapGetters("localstorage", [
      "createQrID",
      "alllangs",
      "defaultLang",
      "mainDatalang",
      "currentlanguage",
    ]),
    currentSourceLang() {
      return this.defaultLang || "fa";
    },
    currentTargetLangCodes() {
      return this.alllangs || [];
    },
    pendingSourceLangFinal() {
      return this.pendingSourceLang || this.currentSourceLang;
    },
    pendingTargetLangCodes() {
      return this.pendingTargetLanguages.map((l) => l.lang);
    },
    addedLangs() {
      return this.pendingTargetLangCodes.filter(
        (l) => !this.currentTargetLangCodes.includes(l)
      );
    },
    removedLangs() {
      return this.currentTargetLangCodes.filter(
        (l) =>
          l &&
          !this.pendingTargetLangCodes.includes(l) &&
          l !== this.pendingSourceLangFinal
      );
    },
    sourceChanged() {
      return this.pendingSourceLangFinal !== this.currentSourceLang;
    },
    pendingCount() {
      return (
        this.addedLangs.length +
        this.removedLangs.length +
        (this.sourceChanged ? 1 : 0)
      );
    },
    hasPendingChanges() {
      return this.pendingCount > 0;
    },
    availableTargetLanguages() {
      const statusMap = new Map();

      this.alllangs.forEach((langCode) => {
        const existing = this.mainDatalang?.data?.data?.langs?.other_langs?.find(
          (ol) => ol.lang === langCode
        );
        statusMap.set(langCode, existing?.status || "edited");
      });

      this.pendingTargetLanguages.forEach((item) => {
        if (!statusMap.has(item.lang)) {
          statusMap.set(item.lang, item.status || "edited");
        } else {
          statusMap.set(item.lang, item.status || statusMap.get(item.lang));
        }
      });

      return this.allLanguages
        .filter((l) => l.lang !== this.pendingSourceLangFinal)
        .map((lang) => ({
          ...lang,
          status: statusMap.get(lang.lang) || "new",
        }));
    },
    allTargetSelected() {
      return (
        this.availableTargetLanguages.length > 0 &&
        this.pendingTargetLanguages.length ===
          this.availableTargetLanguages.length
      );
    },
    sourceLangObj() {
      return (
        this.allLanguages.find((l) => l.lang === this.currentSourceLang) ||
        this.allLanguages[2]
      );
    },
    allLanguages() {
      return [
        { lang: "en_US", name: this.$t("language.lang.en_US"), flag: "/media/flag/us.svg" },
        { lang: "en_GB", name: this.$t("language.lang.en_GB"), flag: "/media/flag/gb.svg" },
        { lang: "fa", name: this.$t("language.lang.fa"), flag: "/media/flag/ir.svg" },
        { lang: "ar", name: this.$t("language.lang.ar"), flag: "/media/flag/sa.svg" },
        { lang: "ar_ae", name: this.$t("language.lang.ar_ae"), flag: "/media/flag/ae.svg" },
        { lang: "ar_iq", name: this.$t("language.lang.ar_iq"), flag: "/media/flag/iq.svg" },
        { lang: "de", name: this.$t("language.lang.de"), flag: "/media/flag/de.svg" },
        { lang: "fr", name: this.$t("language.lang.fr"), flag: "/media/flag/fr.svg" },
        { lang: "hy", name: this.$t("language.lang.hy"), flag: "/media/flag/am.svg" },
        { lang: "ru", name: this.$t("language.lang.ru"), flag: "/media/flag/ru.svg" },
        { lang: "tr", name: this.$t("language.lang.tr"), flag: "/media/flag/tr.svg" },
        { lang: "zh_CN", name: this.$t("language.lang.zh_CN"), flag: "/media/flag/cn.svg" },
        { lang: "zh_TW", name: this.$t("language.lang.zh_TW"), flag: "/media/flag/tw.svg" },
      ];
    },
  },
  methods: {
    ...mapActions("localstorage", [
      "setLangList",
      "setDefaultLang",
      "setCurrentLanguage",
      "setMainData",
    ]),
    cancelChanges() {
      this.pendingSourceLang = null;
      this.pendingTargetLanguages = [...this.initialTargetLanguages];
      this.selectedSourceLang = this.allLanguages.find(
        (l) => l.lang === this.currentSourceLang
      );

      this.$toast.info(this.$t("language.changes_canceled"));
    },
    setStatus(status) {
      const idx = this.pendingTargetLanguages.findIndex(
        (l) => l.lang === this.current.lang
      );

      if (idx !== -1) {
        this.$set(this.pendingTargetLanguages[idx], "status", status);
      } else {
        const langObj = this.allLanguages.find(
          (l) => l.lang === this.current.lang
        );
        if (langObj) {
          this.pendingTargetLanguages.push({
            ...langObj,
            status: status,
          });
        }
      }

      this.pendingTargetLanguages = [...this.pendingTargetLanguages];
      this.dialog = false;
      this.$root.isTranslating = true;
      this.syncToLangs();
      if (this.current.lang === this.sourceLanguage) {
        this.$emit("qrUpdate", {
          data: this.mainData,
          theme: this.theme,
          orders: this.orders,
        });
      }
      this.$root.isTranslating = false;
    },
    syncToLangs() {
      const updated = {
        source_lang: this.sourceLanguage,
        other_langs: this.pendingTargetLanguages.map((l) => ({
          lang: l.lang,
          status: l.status || "edited",
        })),
      };
      const updatedMainData = {
        ...this.data,
        language: this.sourceLanguage,
        langs: updated,
      };
      const ftpContent = {
        data: updatedMainData,
        theme: this.theme,
        orders: this.orders,
      };
      this.$emit("input", updated);
      this.$emit("qrUpdate", ftpContent);
    },
    getChipColor(item) {
      const colorMap = {
        new: "darkolivegreen",
        edited: "blue",
        ai_translated: "purple lighten-3",
      };
      return colorMap[item.status] || "darkolivegreen";
    },

    getIcon(item) {
      const iconMap = {
        new: "mdi-plus-circle-outline",
        edited: "mdi-account-edit",
        ai_translated: "mdi-robot",
      };
      return iconMap[item.status] || "mdi-help-circle";
    },

    getTextColor(item) {
      return this.getChipColor(item) === "blue" ? "black" : "white";
    },
    isTargetLangSelected(item) {
      return this.pendingTargetLanguages.some((l) => l.lang === item.lang);
    },
        openAction(item) {
      const lang = item.lang;
      this.current = item;
      this.currentSelectedLang = lang;
      this.dialog = true;
      this.$root.$emit("editvisit-lang-change", lang);
      
      this.$api
        .get(`/langData?id=${this.createQrID}&lang=${lang}`)
        .then((res) => {
          if (res.data.data.data === null || res.data.data.data === undefined) {
            this.$toast.warning(this.$t("errors.service_unavailable") || "Service Unavailable");
            return;
          }

            const defaultDataStandard = {
              pallete: {
                headColor: "linear-gradient(to right , #1AD6D8FF, #7915A7FF)",
                bodyColor: "linear-gradient(to top left , #9AFEFFFF, #DF99FFFF)",
                textColor: "#ffffff",
                borderColor: "#393939",
                isDarkBody: false,
              },
              visitName: "",
              isGradient: true,
              organizationName: "",
              subOrgan: "",
              userName: "",
              workField: null,
              phoneNumber: [],
              extraFields: [],
              companyNumber: "",
              email: "",
              fax: "",
              location: "",
              city: "",
              photo: {
                profile: "",
                transition: "scale",
                hasWelcome: false,
                headBackground: "",
                gallery: [],
                hasGif: false,
                hasGame: false,
                previewerQr: {
                  previewer: {
                    gif: "",
                    game: {},
                    transition: "scale",
                  },
                },
              },
              codePostal: "",
              province: "",
              country: "",
              website: "",
              socialMedia: {
                address: [],
                instagram: [],
                whatsapp: [],
              },
              aboutUs: "",
              coordinates: [],
              address: "",
              apiKey: "",
              video_gallery: [],
              customerClub: {
                configs: {},
                title: "",
                description: "",
              },
              advanceSettings: {
                viewConfigs: {},
                hasManifestIcons: false,
                manifest: {},
                hasAssistants: false,
                aiChatConfig: {},
              },
              tab_design: 1,
              audiosGallery: {
                audios: [],
                audioType: "newPlayer",
              },
              language: "fa",
              langs: {
                source_lang: "fa",
                other_langs: [],
              },
            };
            const defaultDataPro = {
              consultation: {
                title: "",
                description: "",
                sectionColor: { backGround: "", text: "" },
                items: {},
              },
              consultationNew: {
                title: "",
                description: "",
                sectionColor: { backGround: "", text: "" },
                conform: false,
              },
              FeedBack: {
                title: "",
                description: "",
                sectionColor: { backGround: "", text: "" },
                type: "text",
                items: [],
              },
              pdf: [],
              pdfSelector: {
                title: "",
                description: "",
                sectionColor: { backGround: "", text: "" },
                slider: false,
                layout: "list",
              },
              pallete: {
                headColor: "linear-gradient(to right , #1AD6D8FF, #7915A7FF)",
                bodyColor: "linear-gradient(to top left , #9AFEFFFF, #DF99FFFF)",
                textColor: "#ffffff",
                borderColor: "#393939",
                isDarkBody: false,
              },
              visitName: "",
              isGradient: true,
              organizationName: "",
              subOrgan: "",
              userName: "",
              workField: null,
              phoneNumber: [],
              extraFields: [],
              companyNumber: "",
              email: "",
              fax: "",
              location: "",
              city: "",
              photo: {
                profile: "",
                transition: "scale",
                hasWelcome: false,
                headBackground: "",
                gallery: [],
                hasGif: false,
                hasGame: false,
                previewerQr: {
                  previewer: {
                    gif: "",
                    game: {},
                    transition: "scale",
                  },
                },
              },
              codePostal: "",
              province: "",
              country: "",
              website: "",
              socialMedia: {
                address: [],
                instagram: [],
                whatsapp: [],
              },
              aboutUs: "",
              coordinates: [],
              address: "",
              apiKey: "",
              video_gallery: [],
              customerClub: {
                configs: {},
                title: "",
                description: "",
              },
              advanceSettings: {
                viewConfigs: {},
                hasManifestIcons: false,
                manifest: {},
                hasAssistants: false,
                aiChatConfig: {},
              },
              tab_design: 1,
              audiosGallery: {
                audios: [],
                audioType: "newPlayer",
              },
              language: "fa",
              langs: {
                source_lang: "fa",
                other_langs: [],
              },
            };
            const isPro = ['qr.name.edit.pro', 'qr.name.id.edit.pro'].includes(this.$route.name);
            const defaultData = isPro ? defaultDataPro : defaultDataStandard;
          
            let target = res.data;
            while (target && target.data && target.theme === undefined && target.orders === undefined) {
              target = target.data;
            }
            const serverData = target || {};          
            const mergedData = Object.assign({}, defaultData, serverData.data);
          // -----------------------------------------------------------

          this.data = mergedData;
          this.theme = serverData.theme;
                                  console.log(this.data,"this.data")
                                  console.log(this.theme,"this.theme",res.data.data)

          this.$nextTick(() => {
            this.setCurrentLanguage(lang);
            this.$root.$emit("visit-data-updated", {
              data: {
                data: mergedData, 
                orders: serverData.orders || this.orders,
                theme: serverData.theme || "MobileViwer",
                lang: lang,
              },
            });
          });
          
          if (this.$parent.$options.name === "editVisit") {
            this.$root.$emit("lang-data-loaded", { lang, data: { ...res.data, data: { ...res.data.data, data: mergedData } } });
          }
        })
        .catch(() => {
          this.$toast.error(this.$t("language.error_loading_language"));
        });
    },
    // openAction(item) {
    //   const lang = item.lang;
    //   this.current = item;
    //   this.currentSelectedLang = lang;
    //   this.dialog = true;
    //   this.$root.$emit("editvisit-lang-change", lang);
    //   this.$api
    //     .get(`/langData?id=${this.createQrID}&lang=${lang}`)
    //     .then((res) => {
    //       this.data = res.data.data.data;
    //       this.theme = res.data.data.theme;
    //       if (res.data.data.data === null || res.data.data.data === undefined) {
    //         this.$toast.warning(this.$t("errors.service_unavailable") || "Service Unavailable");
    //         return;
    //       }
    //       this.$nextTick(() => {
    //         this.setCurrentLanguage(lang);
    //         this.$root.$emit("visit-data-updated", {
    //           data: {
    //             data: res.data.data.data || {},
    //             orders: res.data.data.orders || this.orders,
    //             theme: res.data.data.theme || "MobileViwer",
    //             lang: lang,
    //           },
    //         });
    //       });
    //       if (this.$parent.$options.name === "editVisit") {
    //         this.$root.$emit("lang-data-loaded", { lang, data: res.data });
    //       }
    //     })
    //     .catch(() => {
    //       this.$toast.error(this.$t("language.error_loading_language"));
    //     });
    // },
    
    // ۱. اصلاح و بهینه‌سازی انتقال زبان اصلی قبلی به لیست زبان‌ها
    onSourceLangChange(langObj) {
      const oldSource = this.pendingSourceLangFinal;
      const newSource = langObj.lang;

      if (oldSource && oldSource !== newSource) {
        const oldSourceObj = this.allLanguages.find((l) => l.lang === oldSource);
        const alreadyInTargets = this.pendingTargetLanguages.some((l) => l.lang === oldSource);

        if (oldSourceObj && !alreadyInTargets) {
          this.pendingTargetLanguages.push({
            ...oldSourceObj,
            status: "edited",
          });
        }
      }

      this.pendingSourceLang = newSource;
      this.pendingTargetLanguages = this.pendingTargetLanguages.filter(
        (l) => l.lang !== newSource
      );
    },

    removeTargetLang(item) {
      this.pendingTargetLanguages = this.pendingTargetLanguages.filter(
        (l) => l.lang !== item.lang
      );
    },
    toggleSelectAll() {
      if (this.allTargetSelected) {
        this.pendingTargetLanguages = [];
      } else {
        this.pendingTargetLanguages = [...this.availableTargetLanguages];
      }
    },
    selectLanguagedefault(lang) {
      this.$root.isTranslating = true;
      if (!lang) lang = this.currentSourceLang;
      this.activeLang = lang;
      this.setCurrentLanguage(lang);
      this.$root.$emit("language-changed", { lang });
      const safeOrders =
        Array.isArray(this.mainDatalang.data.orders) &&
        this.mainDatalang.data.orders.length > 0
          ? this.mainDatalang.data.orders
          : this.orders;
      this.$root.$emit("visit-data-updated", {
        data: {
          data: this.mainDatalang.data.data || {},
          orders: safeOrders,
          theme: this.mainDatalang.data.theme || "MobileViwer",
          lang,
        },
      });
      this.$root.isTranslating = false;
    },
        loadLangData(lang) {
      if (
        lang === this.currentSourceLang ||
        this.currentTargetLangCodes.includes(lang)
      ) {
        this.$api
          .get(`/langData?id=${this.createQrID}&lang=${lang}`)
          .then((res) => {
            const defaultDataStandard = {
              pallete: {
                headColor: "linear-gradient(to right , #1AD6D8FF, #7915A7FF)",
                bodyColor: "linear-gradient(to top left , #9AFEFFFF, #DF99FFFF)",
                textColor: "#ffffff",
                borderColor: "#393939",
                isDarkBody: false,
              },
              visitName: "",
              isGradient: true,
              organizationName: "",
              subOrgan: "",
              userName: "",
              workField: null,
              phoneNumber: [],
              extraFields: [],
              companyNumber: "",
              email: "",
              fax: "",
              location: "",
              city: "",
              photo: {
                profile: "",
                transition: "scale",
                hasWelcome: false,
                headBackground: "",
                gallery: [],
                hasGif: false,
                hasGame: false,
                previewerQr: {
                  previewer: {
                    gif: "",
                    game: {},
                    transition: "scale",
                  },
                },
              },
              codePostal: "",
              province: "",
              country: "",
              website: "",
              socialMedia: {
                address: [],
                instagram: [],
                whatsapp: [],
              },
              aboutUs: "",
              coordinates: [],
              address: "",
              apiKey: "",
              video_gallery: [],
              customerClub: {
                configs: {},
                title: "",
                description: "",
              },
              advanceSettings: {
                viewConfigs: {},
                hasManifestIcons: false,
                manifest: {},
                hasAssistants: false,
                aiChatConfig: {},
              },
              tab_design: 1,
              audiosGallery: {
                audios: [],
                audioType: "newPlayer",
              },
              language: "fa",
              langs: {
                source_lang: "fa",
                other_langs: [],
              },
            };
            const defaultDataPro = {
              consultation: {
                title: "",
                description: "",
                sectionColor: { backGround: "", text: "" },
                items: {},
              },
              consultationNew: {
                title: "",
                description: "",
                sectionColor: { backGround: "", text: "" },
                conform: false,
              },
              FeedBack: {
                title: "",
                description: "",
                sectionColor: { backGround: "", text: "" },
                type: "text",
                items: [],
              },
              pdf: [],
              pdfSelector: {
                title: "",
                description: "",
                sectionColor: { backGround: "", text: "" },
                slider: false,
                layout: "list",
              },
              pallete: {
                headColor: "linear-gradient(to right , #1AD6D8FF, #7915A7FF)",
                bodyColor: "linear-gradient(to top left , #9AFEFFFF, #DF99FFFF)",
                textColor: "#ffffff",
                borderColor: "#393939",
                isDarkBody: false,
              },
              visitName: "",
              isGradient: true,
              organizationName: "",
              subOrgan: "",
              userName: "",
              workField: null,
              phoneNumber: [],
              extraFields: [],
              companyNumber: "",
              email: "",
              fax: "",
              location: "",
              city: "",
              photo: {
                profile: "",
                transition: "scale",
                hasWelcome: false,
                headBackground: "",
                gallery: [],
                hasGif: false,
                hasGame: false,
                previewerQr: {
                  previewer: {
                    gif: "",
                    game: {},
                    transition: "scale",
                  },
                },
              },
              codePostal: "",
              province: "",
              country: "",
              website: "",
              socialMedia: {
                address: [],
                instagram: [],
                whatsapp: [],
              },
              aboutUs: "",
              coordinates: [],
              address: "",
              apiKey: "",
              video_gallery: [],
              customerClub: {
                configs: {},
                title: "",
                description: "",
              },
              advanceSettings: {
                viewConfigs: {},
                hasManifestIcons: false,
                manifest: {},
                hasAssistants: false,
                aiChatConfig: {},
              },
              tab_design: 1,
              audiosGallery: {
                audios: [],
                audioType: "newPlayer",
              },
              language: "fa",
              langs: {
                source_lang: "fa",
                other_langs: [],
              },
            };
            const isPro = this.$route.name.includes('.pro');
            const defaultData = isPro ? defaultDataPro : defaultDataStandard;

            let target = res.data;
            while (target && target.data && target.theme === undefined && target.orders === undefined) {
              target = target.data;
            }
            const serverData = target || {};
            const mergedData = Object.assign({}, defaultData, serverData.data);
          this.data = mergedData; 
          this.theme = serverData.theme;

            const safeOrders =
              Array.isArray(serverData.orders) &&
              serverData.orders.length > 0
                ? serverData.orders
                : this.orders;
                
            this.$root.$emit("visit-data-updated", {
              data: {
                data: mergedData,
                orders: safeOrders,
                theme: serverData.theme || "MobileViwer",
                lang,
              },
            });
          })
          .catch(() => {
            this.$toast.error(this.$t("language.error_loading_language"));
          });
      }
    },

    // loadLangData(lang) {
    //   if (
    //     lang === this.currentSourceLang ||
    //     this.currentTargetLangCodes.includes(lang)
    //   ) {
    //     this.$api
    //       .get(`/langData?id=${this.createQrID}&lang=${lang}`)
    //       .then((res) => {
    //         const safeOrders =
    //           Array.isArray(res.data.data.orders) &&
    //           res.data.data.orders.length > 0
    //             ? res.data.data.orders
    //             : this.orders;
    //         this.$root.$emit("visit-data-updated", {
    //           data: {
    //             data: res.data.data.data || {},
    //             orders: safeOrders,
    //             theme: res.data.data.theme || "MobileViwer",
    //             lang,
    //           },
    //         });
    //       })
    //       .catch(() => {
    //         this.$toast.error(this.$t("language.error_loading_language"));
    //       });
    //   }
    // },
    
    // ۲. حذف کدهای تکراری در انتخاب زبان
    selectLanguage(lang) {
      this.activeLang = lang;
      this.setCurrentLanguage(lang);
      this.$root.$emit("language-changed", { lang });

      this.loadLangData(lang);
      this.$root.isTranslating = false;
    },

    // ۳. جلوگیری از درخواست تکراری فچ کردن اطلاعات زبان در کلیک روی چیپ‌ها
    openAndSelect(item) {
      const isNewLang = !this.currentTargetLangCodes.includes(item.lang);

      if (isNewLang) {
        this.$toast.warning(this.$t("language.apply_changes_first_to_edit"), {
          timeout: 5000,
          position: "top-center",
          icon: "mdi-alert-outline",
          action: {
            text: this.$t("language.apply_changes"),
            onClick: (e, toast) => {
              toast.goAway(0);
              this.$nextTick(() => {
                this.$vuetify.goTo(".btn-download", {
                  duration: 500,
                  offset: 100,
                });
              });
            },
          },
        });
        return;
      }
      this.current = item;
      
      // فراخوانی اکشن اصلی که به تنهایی دیتای زبان رو میگیره
      this.openAction(item);
      
      // تنها تغییر استیت‌های ظاهری بجای درخواست مجدد در selectLanguage
      this.activeLang = item.lang;
      this.$root.$emit("language-changed", { lang: item.lang });
      this.$root.isTranslating = false;
    },

    // ۴. منطق تصحیح شده برای Race Condition (با ترتیب اجرا ۱. آپدیت ۲. تغییر ۳. حذف)
    async applyPendingChanges() {
      if (this.applying || !this.hasPendingChanges) return;
      this.applying = true;
      try {
        const updatedLangs = {
          source_lang: this.pendingSourceLangFinal,
          other_langs: this.pendingTargetLanguages.map((l) => ({
            lang: l.lang,
            status: l.status || "edited",
          })),
        };

        const updatedMainData = {
          ...this.mainDatalang.data.data,
          language: this.pendingSourceLangFinal,
          langs: updatedLangs,
        };

        const ftpContent = {
          data: updatedMainData,
          theme: this.theme,
          orders: this.orders,
        };

        // مرحله ۱: آپدیت دیتا (زبان اصلی قبلی اینجا تبدیل به فایل JSON میشه)
        await this.$api.post(`/v1/testQr/update-lang-data/${this.createQrID}`, {
          data: ftpContent,
          langs: this.pendingTargetLangCodes,
        });

        // مرحله ۲: تغییر زبان پیش‌فرض
        if (this.sourceChanged) {
          await this.$api.post(
            `/v1/testQr/change-default-lang/${this.createQrID}`,
            {
              default: this.pendingSourceLangFinal,
            }
          );
        }

        // مرحله ۳: حذف زبان‌های ناخواسته
        const validRemovedLangs = this.currentTargetLangCodes.filter(
          (l) =>
            l &&
            !this.pendingTargetLangCodes.includes(l) &&
            l !== this.pendingSourceLangFinal
        );

        if (validRemovedLangs.length > 0) {
          const param = `lang=${validRemovedLangs.join(",")}`;
          await this.$api.delete(
            `/v1/testQr/delete-lang-data?${param}&id=${this.createQrID}`
          );
        }

        this.$toast.success(this.$t("language.changes_applied_successfully"));

        this.setDefaultLang(this.pendingSourceLangFinal);
        this.setLangList(this.pendingTargetLangCodes);

        if (
          !this.pendingTargetLangCodes.includes(this.activeLang) &&
          this.activeLang !== this.pendingSourceLangFinal
        ) {
          this.selectLanguagedefault(this.pendingSourceLangFinal);
        }

        this.$emit("input", updatedLangs);
        this.$emit("qrUpdate", ftpContent);

        this.pendingSourceLang = null;
        this.initialTargetLanguages = [...this.pendingTargetLanguages];
      } catch (err) {
        console.error(err);
        this.$toast.error(this.$t("language.error_applying_changes"));
      } finally {
        this.applying = false;
      }
    },
  },
  watch: {
    currentlanguage: {
      handler(val) {
        const lang =
          typeof val === "string" ? val : val?.lang || this.currentSourceLang;
        this.activeLang = lang;
      },
      immediate: true,
    },
  },
  mounted() {
    this.selectedSourceLang = this.allLanguages.find(
      (l) => l.lang === this.currentSourceLang
    );
    this.activeLang = this.currentSourceLang || this.currentlanguage;

    const currentOtherLangs =
      this.mainDatalang?.data?.data?.langs?.other_langs || [];
    this.pendingTargetLanguages = currentOtherLangs
      .map((ol) => {
        const base = this.allLanguages.find((l) => l.lang === ol.lang);
        return base ? { ...base, status: ol.status || "edited" } : null;
      })
      .filter(Boolean);
    this.initialSourceLang = this.currentSourceLang;

    this.initialTargetLanguages = currentOtherLangs
      .map((ol) => {
        const base = this.allLanguages.find((l) => l.lang === ol.lang);
        return base ? { ...base, status: ol.status || "edited" } : null;
      })
      .filter(Boolean);

    this.pendingTargetLanguages = [...this.initialTargetLanguages];
    this.pendingSourceLang = null;
    this.$root.$on("visit-data-updated", (payload) => {
      this.data = payload.data.data;
      this.orders = payload.data.orders?.length
        ? payload.data.orders
        : this.orders;
      this.theme = payload.data.theme || "MobileViwer";
    });
  },
  beforeDestroy() {
    this.$root.$off("visit-data-updated");
  },
};
</script>

<style scoped>
.v-chip {
  transition: all 0.2s ease;
}
.v-chip:hover {
  transform: scale(1.15);
}
.btn-download-badge .v-badge__badge {
  font-size: 12px !important;
  font-weight: bold !important;
  min-width: 22px !important;
  height: 22px !important;
  border-radius: 11px !important;
}
.btn-download-badge:hover .v-badge__badge {
  transform: scale(1.1);
}
</style>
